import React from 'react';
import { useEffect, useRef, useState, createRef } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  SLowcodeList,
  SIDRender,
} from 'shj-components'
import { getAuth } from '@/utils/auth'
import config from './config';
import { Button, Form, Input, message, Modal, Table } from 'antd'
import { refundApplyFindResponseListByPageForMainPage, httpDictServTenant, getEnum } from '@/services/fmsServices'
import dayjs from 'dayjs'
import styles from '../receivableList/index.module.less'
const { TextArea } = Input;
export default function PaymentServiceManage() {
  const auth = getAuth()
  const history = useNavigate();
  const [openModal, setModal] = useState(false);
  const [editData, setEditData] = useState<any>(null);
  const listRef = useRef<any>();
  const childRef = createRef<any>()
  let [form] = Form.useForm();
  // 表格加载
  const fetchList = (values: any) => {
    const { current, pageSize, ...rest } = values;
    return new Promise(async (resolve, reject) => {
      try {
        const { current, pageSize, query } = values
        if (query.applyTime) {
          query.applyTimeBegin = dayjs(query.applyTime[0]).format('YYYY-MM-DD 00:00:00')
          query.applyTimeEnd = dayjs(query.applyTime[1]).format('YYYY-MM-DD 23:59:59')
        }
        if(query?.refundStateList){
          query.refundStateList = [query.refundStateList]
        }
        if(query?.refundTypeList){
          query.refundTypeList = [query.refundTypeList]
        }
        
        refundApplyFindResponseListByPageForMainPage(current, pageSize, query).then((res) => {
          resolve(res)
        })
      } catch (e) {
        reject({ success: false });
      }
    });
  };
  // 刷新
  const reloadFn = () => {
    const {
      current: { reload },
    } = listRef;
    reload();
  };
  const onDetail = (record: any) => {
    setEditData({ ...record, type: 'see' })
    setModal(true)
  }
  const getStatusOptions = () => {
    return new Promise(async resolve => {
      let refundTypeList = await httpDictServTenant({ parentKey: 'refundType',enabled: 1 })
      const refundStatusList: any = await getEnum('com.shj.saas.plus.fms.enums.refund.RefundStateEnum')
      resolve({
        refundTypeList,
        refundStatusList,
      })
    })
  }



  // 右侧表格配置
  const extension = {
    request: { fetchList, getStatusOptions },
    events: { },
    customRender: {
      IdRender(text: any, record: any) {
        return (
          <SIDRender id={text} onClick={() => onDetail(record)} copy={false}></SIDRender>
        )
      },
    },
  }
  return (
    <div className={styles.FmsDragTable}>
      <SLowcodeList config={config} ref={listRef} {...extension} 
        searchMode="group"
      />
    </div>
  )
}